export const IMAGE_TYPE = {
  FRONT: 'frontImage',
  BACK: 'backImage'
};
export const CHECK_DEPOSIT_TYPES = ['checkDeposit', 'Check Deposit'];
